import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import createStyles from "@material-ui/core/styles/createStyles";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { fade, Theme } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loader: {
      top: 0,
      left: 0,
      right: 0,
      display: "flex",
      height: "100%",
      alignItems: "center",
      justifyContent: "center",
      position: "fixed",
      zIndex: theme.zIndex.appBar + 1,
      padding: theme.spacing(1),
      backgroundColor: fade(theme.palette.primary.contrastText, 0.75),
    },
  }),
);

const Loading = ({ className = {} }) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.loader, className)}>
      <CircularProgress color={"primary"} />
    </div>
  );
};

export default React.memo(Loading);
